<template>
    <div>
        <section id="testimonials" class="py-24 bg-white">
            <div class="max-w-7xl mx-auto px-4">
                <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">L'avis des professionnels</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    <div class="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                        <div class="flex text-orange-400 mb-4 text-sm">
                            <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>
                        </div>
                        <p class="text-gray-700 italic mb-6">"Une révolution pour notre PME. On a arrêté le papier du jour au lendemain. Les techniciens adorent l'application."</p>
                        <div class="flex items-center gap-3">
                            <img src="https://storage.victoranw.fr/file/VFgdseeWLD" alt="Avatar Julien M." class="w-10 h-10 rounded-full object-cover">
                            <div>
                                <p class="font-bold text-gray-900">Julien M.</p>
                                <p class="text-xs text-gray-500">Gérant</p>
                            </div>
                        </div>
                    </div>
                     <div class="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
                        <div class="flex text-orange-400 mb-4 text-sm">
                            <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>
                        </div>
                        <p class="text-gray-700 italic mb-6">"La gestion des interventions est devenue tellement simple. On planifie tout en quelques clics et on voit l'activité en temps réel."</p>
                        <div class="flex items-center gap-3">
                            <img src="https://storage.victoranw.fr/file/lAJW5SAOko" alt="Avatar Sarah L." class="w-10 h-10 rounded-full object-cover">
                            <div>
                                <p class="font-bold text-gray-900">Sarah L.</p>
                                <p class="text-xs text-gray-500">Directrice Admin</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>